import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { DollarSign, Download, PieChart } from "lucide-react";

export function FinancialTab() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold mb-2">Financial Reports</h2>
          <p className="text-muted-foreground">Track revenue, expenses, and profitability</p>
        </div>
        <Button variant="outline" className="gap-2">
          <Download className="w-4 h-4" />
          Export Reports
        </Button>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card className="p-6">
          <p className="text-sm text-muted-foreground mb-1">Total Revenue</p>
          <p className="text-3xl font-bold mb-2">$0</p>
          <p className="text-xs text-muted-foreground">Current month</p>
        </Card>

        <Card className="p-6">
          <p className="text-sm text-muted-foreground mb-1">Outstanding</p>
          <p className="text-3xl font-bold mb-2">$0</p>
          <p className="text-xs text-muted-foreground">Pending payments</p>
        </Card>

        <Card className="p-6">
          <p className="text-sm text-muted-foreground mb-1">Expenses</p>
          <p className="text-3xl font-bold mb-2">$0</p>
          <p className="text-xs text-muted-foreground">This month</p>
        </Card>

        <Card className="p-6">
          <p className="text-sm text-muted-foreground mb-1">Profit Margin</p>
          <p className="text-3xl font-bold mb-2">0%</p>
          <p className="text-xs text-muted-foreground">Net margin</p>
        </Card>
      </div>

      {/* Financial Dashboard Placeholder */}
      <Card className="p-6">
        <div className="flex items-center gap-3 mb-4">
          <DollarSign className="w-5 h-5 text-primary" />
          <h3 className="text-lg font-semibold">Financial Dashboard</h3>
        </div>
        <p className="text-muted-foreground mb-6">
          Track revenue, expenses, and profitability
        </p>
        
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <PieChart className="w-16 h-16 text-muted-foreground mb-4" />
          <p className="text-muted-foreground">Financial tracking coming soon</p>
        </div>
      </Card>
    </div>
  );
}
